import { searchGlobal } from '@/api/global-search'

const state = {
  fetchingList: false,
  globalSearchOrders: [],
  globalSearchOrdersCount: 0,
}

const mutations = {
  ADD_LIST_SEARCH_GLOBAL(state, { data }) {
    state.globalSearchOrders = data.data
    state.globalSearchOrdersCount = data.total
  },
  CLEAR_SEARCH_GLOBAL(state) {
    state.globalSearchOrders = []
    state.globalSearchOrdersCount = 0
  },
}

const getters = {
  getListGlobalSearch: (state) => {
    return state.globalSearchOrders
  },
  getTotalGlobalSearch: (state) => {
    return state.globalSearchOrdersCount
  },
}

const actions = {
  async searchGlobal({ commit }, value) {
    try {
      commit('SET_FETCHING', { name: 'fetchingList', value: true })
      const result = await searchGlobal(value)
      commit('SET_FETCHING', { name: 'fetchingList', value: false })
      commit('ADD_LIST_SEARCH_GLOBAL', {
        data: result?.data?.data?.merchantOrders,
      })
    } catch (error) {
      commit('SET_ERROR', error)
      commit('SET_FETCHING', { name: 'fetchingList', value: false })
    }
  },
  async clearSearchResult({ commit }, value) {
    commit('CLEAR_SEARCH_GLOBAL')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
